import { Component } from "react"
import PropTypes from "prop-types"
import Cookies from "js-cookie"

export default class PartnerUpdates extends Component {
  constructor(props) {
    super(props)

    this.state = {
      display: props.display,
    }

    this.onClickNotice = this.onClickNotice.bind(this)
    this.onHideNotice = this.onHideNotice.bind(this)
  }

  onClickNotice() {
    window.uiEventTracker.trackUserInteraction(
      "panda.partners-update.clicked",
      {
        service_id: window.App.pageViewData.service_id,
        user_id: window.App.pageViewData.user_id,
      }
    )
  }

  onHideNotice() {
    this.setState({ display: false })
    this.markAsRead()

    window.uiEventTracker.trackUserInteraction("panda.partners-update.closed", {
      service_id: window.App.pageViewData.service_id,
      user_id: window.App.pageViewData.user_id,
    })
  }

  markAsRead() {
    let domain = window.location.hostname
    let parts = domain.split(".").slice(-2)

    // prepending an empty string to our domain makes this a global cookie
    // that can be shared accross all subdomains
    domain = [""].concat(parts).join(".")

    Cookies.set("partners_update_version", this.props.version, {
      domain,
      expires: 365,
    })
  }

  render() {
    if (!this.state.display) {
      return <div />
    }

    window.uiEventTracker.trackUserInteraction(
      "panda.partners-update.rendered",
      {
        service_id: window.App.pageViewData.service_id,
        user_id: window.App.pageViewData.user_id,
      }
    )

    return (
      <div className="partners-update" onClick={this.onClickNotice}>
        <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
        <div
          className="hide"
          title="Hide this notice"
          onClick={this.onHideNotice}
        />
      </div>
    )
  }
}

PartnerUpdates.propTypes = {
  display: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
}
